module.exports = __webpack_public_path__ + "media/assets/faria_products/Reports-a7fee7bf4663b6077a1e4b6b02ffc7894e8babb94029b0a494ce735c9b741b49.png";